import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
export default function AsSeenOn() {
  const press = [
    {
      logo: "/images/projects/house.svg",
    },
    {
      logo: "/images/projects/design.svg",
    },
    {
      logo: "/images/projects/gen20.svg",
    },
    {
      logo: "/images/projects/goodhomes.svg",
    },
  ];
  const breakpoints = {
    1280: {
      slidesPerView: 5.4,
      spaceBetween: 30,
    },
    991: {
      slidesPerView: 4.4,
      spaceBetween: 20,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 3.1,
      spaceBetween: 20,
    },
    325: {
      slidesPerView: 2.4,
      spaceBetween: 15,
    },
  };
  return (
    <Section>
      <div className="flex flex-col w-full mx-auto gap-8">
        <p className="font-havletica text-[#292929]/70 text-center mx-auto lg:text-lg text-base">
          As Seen on
        </p>
        <div className="grid md:grid-cols-4 grid-cols-2 auto-rows-auto items-center gap-20 w-fit mx-auto">
          {press.map((partner, key) => (
            <div
              key={"seenBy" + key}
              className="relative md:w-[102px] md:h-[42px] w-[100px] h-[30px]"
            >
              <Image
                src={partner?.logo}
                alt={"partner icon"}
                sizes="(max-width: 479px) 500px, 500px"
                fill
                className="w-full h-full object-contain object-center"
              />
            </div>
          ))}
        </div>
        {/* <Carousel
          slidesPerView={5.4}
          spaceBetween={30}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          showNavAbove={false}
          title="Press & Media"
        >
          {press.map((partner, key) => (
            <SwiperSlide key={"partner" + key}>
              <a
                href={partner?.link ?? "#"}
                target="_blank"
                rel="noreferrer"
                className="w-full flex items-center justify-center"
              >
                <div className="relative md:w-[155px] md:h-[155px] w-[100px] h-[100px]">
                  <Image
                    src={partner?.logo?.data?.attributes?.url}
                    alt={
                      partner?.title ??
                      partner?.logo?.data?.attributes?.alternativeText ??
                      "partner icon"
                    }
                    sizes="(max-width: 479px) 500px, 500px"
                    fill
                    className="w-full h-full object-contain object-center"
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Carousel> */}
      </div>
    </Section>
  );
}
